/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const skillSummarySchema = z.object({
  assignmentId: z.int().nullish(),
  id: z.int(),
  isCritical: z.boolean(),
  name: z.string(),
});
